module.exports = __webpack_public_path__ + "static/media/building11.b7e7f36b.svg";